import { render, staticRenderFns } from "./SendCancelModal.vue?vue&type=template&id=5e8e5027&scoped=true&lang=pug"
import script from "./SendCancelModal.vue?vue&type=script&lang=js"
export * from "./SendCancelModal.vue?vue&type=script&lang=js"
import style0 from "./SendCancelModal.vue?vue&type=style&index=0&id=5e8e5027&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8e5027",
  null
  
)

export default component.exports